export const STEP_FIELDS = {
  0: ['budgetName', 'budgetType', 'budgetPeriod'],
  1: [
    'currentBudgetYear',
    'actualBudgetFrom',
    'actualBudgetTo',
    'proposedBudgetFill',
    'intacctYTDActuals',
    'commentsFill',
  ],
};

export const ACTIVE_STEP_INDEX_LAST = 1;

export const ACTIVE_STEP_INDEX_FIRST = 0;
